import React, { useState } from 'react';
import Anotations from './Anotations';
import ContactsTable from './ContactsTable';
import HistoryTable from './HistoryTable';
import { MessagesTable } from './MessagesTable';
import { MessagesTableAncora } from './MessagesTableAncora';
import { EmailsInterest } from './EmailsInterest'
import NotesTable from './NotesTable';
import OperationTable from './OperationTable';

function OperationsMiddle({
  provider,
  setAtualizaAbatimentoDesconto,
  atualizarAbatimentoDesconto,
  setProvider,
  anchorId,
  providerInfo,
  setProviderInfo,
  setUpdateRightTable,
  updateInfo,
  setUpdateInfo,
  reloadPage,
  setOpcoesButtons,
  setReloadRightTable,
  cargos,
  loginId,
  heightTableAnotacoes,
  heightTableNotas,
  heightTableHistoricos,
  consultarAgendamentos
}) {
  const [updatedNotes, setUpdatedNotes] = useState([]);
  const [screenControls, setScreenControls] = useState([]);
  const [notesToAdd, setNotesToAdd] = useState([]);
  const [notesToRemove, setNotesToRemove] = useState([]);
  const [statusPropose, setStatusPropose] = useState(false);
  const [operationConclusionAncora, setOperationConclusionAncora] = useState({});
  const [operationConclusion, setOperationConclusion] = useState({});
  const [emailInteresseConclusao, setEmailInteresseConclusao] = useState({});

  const [isLoading, setIsLoading] = useState(false);

  return (
    <>
      <OperationTable
        provider={provider}
        setAtualizaAbatimentoDesconto={setAtualizaAbatimentoDesconto}
        setProvider={setProvider}
        anchorId={anchorId}
        setUpdatedNotes={setUpdatedNotes}
        setScreenControls={setScreenControls}
        providerInfo={providerInfo}
        setProviderInfo={setProviderInfo}
        notesToRemove={notesToRemove}
        notesToAdd={notesToAdd}
        setNotesToRemove={setNotesToRemove}
        setNotesToAdd={setNotesToAdd}
        setIsLoading={setIsLoading}
        isLoading={isLoading}
        setUpdateRightTable={setUpdateRightTable}
        setStatusPropose={setStatusPropose}
        updateInfo={updateInfo}
        setUpdateInfo={setUpdateInfo}
        setOperationConclusionAncora={setOperationConclusionAncora}
        setOperationConclusion={setOperationConclusion}
        setOpcoesButtons={setOpcoesButtons}
        setReloadRightTable={setReloadRightTable}
        setEmailInteresseConclusao={setEmailInteresseConclusao}
      />
      <MessagesTableAncora statusPropose={statusPropose} operationConclusionAncora={operationConclusionAncora} />
      <MessagesTable statusPropose={statusPropose} operationConclusion={operationConclusion} />
      <EmailsInterest statusPropose={statusPropose} emailInteresseConclusao={emailInteresseConclusao}/>
      <ContactsTable
        providerInfo={providerInfo}
        provider={provider}
        anchorId={anchorId}
        statusPropose={statusPropose}
        cargos={cargos}
        loginId={loginId}
      />
      <Anotations
        provider={provider}
        anchorId={anchorId}
        statusPropose={statusPropose}
        setAtualizaAbatimentoDesconto={setAtualizaAbatimentoDesconto}
        atualizarAbatimentoDesconto={atualizarAbatimentoDesconto}
        maxHeight={heightTableAnotacoes}
        consultarAgendamentos={consultarAgendamentos}
      />
      <NotesTable
        provider={provider}
        providerInfo={providerInfo}
        updatedNotes={updatedNotes}
        screenControls={screenControls}
        setNotesToRemove={setNotesToRemove}
        setNotesToAdd={setNotesToAdd}
        isLoading={isLoading}
        statusPropose={statusPropose}
        maxHeight={heightTableNotas}
      />
      <HistoryTable
        provider={provider}
        anchorId={anchorId}
        statusPropose={statusPropose}
        reloadPage={reloadPage}
        setUpdateInfo={setUpdateInfo}
        providerInfo={providerInfo}
        setAtualizaAbatimentoDesconto={setAtualizaAbatimentoDesconto}
        atualizarAbatimentoDesconto={atualizarAbatimentoDesconto}
        maxHeight={heightTableHistoricos}
      />
    </>
  );
}

export default OperationsMiddle;
